import { ISearchFields, TSortsFields } from 'types/searchFields';

/**
 * Единое правило порядка выдачи поиска (`POST /search`) для всего приложения:
 * списков, пикеров, модалок, поиска в заказе и поиска по номеру телефона.
 * Применяется в `SearchGroup.search`, поэтому новые места поиска получают его
 * сами, без настройки на месте.
 *
 * Выдача по запросу ранжируется по релевантности: выше более длинное совпадение,
 * а при равной длине — то, что ближе к началу имени, фамилии или номера
 * (`ElasticSearchService`, `sort_by=relevance`).
 */

/**
 * Выключатель ранжирования. На стенде режим `relevance` пока отдаёт пустую
 * выдачу (ошибка на бэке) — до её исправления можно поставить `false`, и поиск
 * вернётся к прежнему порядку без правок в местах вызова.
 */
const IS_RELEVANCE_ENABLED = true;

/** Сортировка по релевантности; `desc` — лучшие совпадения сверху */
export const RELEVANCE_SORT: TSortsFields = { sort_by: 'relevance', sort_dir: 'desc' };

/**
 * Сортировки «по умолчанию», которые уступают релевантности: не задана вовсе
 * или по названию — так стоит в списках и пикерах. Явно выбранные дата, цена
 * и прочие остаются: в заказах, транзакциях и журнале важен порядок по времени.
 */
const isDefaultSort = (sort?: TSortsFields) => !sort?.sort_by || sort.sort_by === 'name';

export const applySearchRanking = (searchFields: ISearchFields): ISearchFields => {
    if (!IS_RELEVANCE_ENABLED) return searchFields;
    // Без запроса ранжировать нечего — список остаётся в своей сортировке
    if (!searchFields.term?.trim()) return searchFields;
    if (!isDefaultSort(searchFields.filter?.sort)) return searchFields;

    return {
        ...searchFields,
        filter: { ...searchFields.filter, sort: RELEVANCE_SORT },
    };
};
